module.exports = __webpack_public_path__ + "DINNextLTPro-BlackCondensed.woff2?51b79862a470ae51621f1cded9419a53";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BlackCondensed.woff2
// module id = 1373
// module chunks = 0